<template>
  <b-container fluid>
    <b-row class="justify-content-between flex-center py-2">
      <b-col cols="12" class="text-center">
        <h3>{{ event.name }}</h3>
      </b-col>
    </b-row>

    <hr />

    <!-- <b-row class="w-100 noMargin py-2" v-if="gateReads">
            <b-col cols="12" class="eventDash p-2" v-if="event.with_sectors">
                <h5 class="text-center">
                    {{$t('dashboard.event.total')}}: {{ totalTickets }}
                </h5>
            </b-col>
            <b-col cols="4" class="eventDash p-2"  v-for="item in gateReads">
                <h5 class="text-center"> {{$t('logs.gate')}} {{ item.gate_id }} </h5>
                <h6 class="px-2">{{$t('dashboard.event.gate')}}: {{ item.total_tickets }}</h6>
            </b-col>
    </b-row>-->

    <b-container fluid>
      <b-row class="py-2 shadow-lg dashboardTile">
        <b-col cols="12" md="6" lg="4" offset-lg="2">
          <h5 class="flex-center">Scanned tickets per gates</h5>
          <div>
            <apexchart width="100%" type="bar" :options="chartOptions" :series="series"></apexchart>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="4" class="flex-center flex-column">
          <h5 class="flex-center">Tickets info</h5>
          <div>
            <apexchart type="radialBar" :options="chartOptions2" :series="series2" />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <hr class="d-none d-md-block" />
    <fullscreen ref="fullscreen" @change="full">
      <b-container fluid class="flex-column shadow-lg p-2 dashboardTile d-none d-md-block">
        <b-row class="d-none d-md-block">
          <b-col cols="12">
            <i class="fas fa-expand fa float-right" @click="toggle"></i>
          </b-col>
        </b-row>

        <b-row class="w-100 noMargin py-2" v-if="event.with_sectors">
          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 7"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 8"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 9"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id && item.with_tickets === true"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="w-100 noMargin py-2 sectorsRow" v-else>
          <b-col cols="12" class="noSectorDash noMargin flex-center flex-column">
            <h4 class="text-center">{{event.scanned}}</h4>
          </b-col>
        </b-row>

      </b-container>
      <b-container fluid class="flex-column mt-2 shadow-lg p-2 dashboardTile d-none d-md-block">
         <b-row class="w-100 noMargin py-2">
          <b-col cols="2" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 4"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="p-4 sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="8" class="d-none d-md-block">
            <b-row class="w-100 noMargin h-100">
              <b-col class="noMargin flex-center">
                <b-img
                  :src="require('../../assets/img/footballfield3.jpg')"
                  fluid
                  alt="Responsive image"
                ></b-img>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="2" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 6"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="p-4 sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>

      <b-container v-if="event.with_sectors" fluid class="flex-column mt-2 shadow-lg p-2 dashboardTile d-none d-md-block">
        <b-row class="w-100 noMargin py-2 sectorsRow2">
          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 1"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 2"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4" class="d-none d-md-block">
            <b-row class="w-100 noMargin py-2 h-100">
              <b-col
                :cols="item.size"
                v-for="item in sectors"
                v-if="item.position === 3"
                v-bind:class="{'sectorDashDis': (item.with_tickets === false)}"
                class="sectorDash noMargin flex-center flex-column"
              >
                <h4 class="p-1 text-center">
                  {{item.code}}
                  <span
                    v-for="read in sectorGateReads"
                    v-if="read.sector_id === item.id"
                    class="px-2 text-center"
                  >- {{read.total_tickets}}</span>
                </h4>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid class="flex-column shadow-lg mt-2 p-2 dashboardTile flex-center d-md-none">
        <b-row class="w-100 noMargin h-100">
          <b-col cols="12" class="noMargin flex-center">
            <h6 class="flex-center text-center">
              <b>Please rotate the screen for sectors overview!</b>
            </h6>
          </b-col>
        </b-row>
      </b-container>
    </fullscreen>
  </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "dashboardEvent",
  data() {
    let totalTickets2 = 8000;
    return {
      fullscreen: false,
      chartOptions: {
        tooltip: {
          y: {
            formatter: function(val) {
              return parseInt(val) + " tickets";
            }
          }
        },
        chart: {
          id: "gates-tickets"
        },
        xaxis: {
          categories: [
            "Gate 1",
            "Gate 2",
            "Gate 3",
            "Gate 4",
            "Gate 5",
            "Gate 6",
            "Gate 7",
            "Gate 8",
            "Gate 9",
            "Gate 10",
            "Gate 11",
            "Gate 12",
            "Gate 13",
            "Gate 14",
            "Gate 15"
          ]
        },
        yaxis: {}
      },
      series: [
        {
          name: "Total",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],

      series2: [0, 0, 0],
      chartOptions2: {
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
              image: undefined
            },
            dataLabels: {
              show: true,
              name: {
                show: true,
                fontSize: "18px",
                fontFamily: undefined,
                color: undefined,
                offsetY: 0
              },
              value: {
                show: true,
                fontSize: "16px",
                fontFamily: undefined,
                color: undefined,
                offsetY: 0,
                formatter: function(val) {
                  return val;
                }
              }
            }
          }
        },
        colors: ["#1ab7ea", "#0084ff", "#39539E"],
        labels: ["Total", "Sold", "Scanned"],
        legend: {
          show: false,
          floating: true,
          fontSize: "14px",
          position: "left",
          offsetX: 160,
          offsetY: 10,
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 0
          },
          formatter: function(seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          },
          itemMargin: {
            horizontal: 1
          }
        }
      },

      totalTickets: 0,
      events: {},
      event: {
        total: 0,
        sold: 0,
        scanned: 0
      },
      gateReads: [],
      sectors: [],
      sectorGateReads: null,
      sectorsWithTickets: null,
      gateRead: {}
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    getGatesChartData() {
      let dataArr = [0, 0, 0, 0, 0, 0];
      //let dataArrTickets = [0, 0, 0];

      this.series2 = [
        (parseInt(this.event.total) / parseInt(this.event.total)) * 100,
        (parseInt(this.event.sold) / parseInt(this.event.total)) * 100,
        (parseInt(this.event.scanned) / parseInt(this.event.total)) * 100
      ];

      for (let i = 0; i < this.gateReads.length; i++) {
        dataArr[parseInt(this.gateReads[i].gate_id) - 1] = parseInt(
          this.gateReads[i].total_tickets
        );
      }
      this.chartOptions = {
        xaxis: {
          categories: [
            "Gate 1",
            "Gate 2",
            "Gate 3",
            "Gate 4",
            "Gate 5",
            "Gate 6",
            "Gate 7",
            "Gate 8",
            "Gate 9",
            "Gate 10",
            "Gate 11",
            "Gate 12",
            "Gate 13",
            "Gate 14",
            "Gate 15"
          ]
        }
      };
      this.series = [
        {
          data: dataArr
        }
      ];

      //this.series2 = dataArrTickets;
      let self = this;

      this.chartOptions2 = {
        plotOptions: {
          radialBar: {
            dataLabels: {
              show: true,
              value: {
                formatter: function(val) {
                  return parseInt((val * self.event.total) / 100);
                }
              }
            }
          }
        }
      };
    },
    toggle() {
      this.$refs["fullscreen"].toggle();
    },
    full(fullscreen) {
      this.fullscreen = fullscreen;
    },

    getEvent() {
      this.$axios
        .get("/eventsDash/getById", {
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.event = response.data.data;
          }
        });
    },
    getGateReads() {
      this.$axios
        .get("/gateReads", {
          params: {
            event_id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.gateReads = response.data.data;
            this.getGatesChartData();
          }
        });
    },
    getSectors() {
      this.$axios.get("sectors").then(response => {
        if (response.status === 200) {
          this.sectors = response.data.data;
        }
      });
    },
    getSectorGateReads() {
      this.$axios
        .get("/sectorGateReads", {
          params: {
            event_id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.sectorGateReads = response.data.data;
          }
        });
    },
    getSectorsWithTickets() {
      this.$axios
        .get("/sectorsWithTickets", {
          params: {
            event_id: this.$route.params.id
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.sectors = response.data.data;
          }
        });
    },
    getTotalTickets() {
      this.totalTickets = 0;
      for (let i = 0; i < this.gateReads.length; i++)
        this.totalTickets += parseInt(this.gateReads[i].total_tickets);
    }
  },
  created() {
    let self = this;
    this.getSectors();
    this.getEvent();
    this.getGateReads();
    this.getSectorGateReads();
    this.getSectorsWithTickets();
    this.interval = setInterval(function() {
      self.getEvent();
      self.getGateReads();
      self.getSectorGateReads();
      self.getSectorsWithTickets();
    }, 3000);
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>

<style  lang="scss">
.sectorsRow {
  height: 30vh;
}
.sectorsRow2 {
  height: 15vh;
}
.sectorDash {
  color: #fff;
  background-image: url("../../assets/img/login.jpg") !important;
  border: 5px solid #fff;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background: #455a64;
  }
}

.sectorDashDis {
  color: #fff;
  background: #455a64 !important;
  border: 5px solid #fff;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background: #455a64;
  }
}

.noSectorDash {
  color: #fff;
  background-color: #0093E9;
  background-image: linear-gradient(160deg, #0093E9 0%, #80D0C7 100%);
  border: 5px solid #fff;
  border-radius: 10px;
}
</style>